import React from 'react';

import './style.css';

class Totalizer extends React.Component {
  render() {
    const {
      name,
      total,
    } = this.props;

    return (
      <div className="Totalizer__root">
        <p><b>{name}:</b> {total}</p>
      </div>
    );
  }
}

export default Totalizer;
